import Application from '@app';
import ReactDOM from 'react-dom/client';
import i18n from './application/locales';
import { Toaster } from 'react-hot-toast';
import { styled } from '@mui/material/styles';
import GlobalEventListener from '@app/events';
import reportWebVitals from './reportWebVitals';
import LoginPage from '@app/pages/public/Login';
import { I18nextProvider } from 'react-i18next';
import { Translator } from '@app/utils/translator';
import { HelmetProvider } from 'react-helmet-async';
import Impersonate from '@app/pages/public/Impersonate';
import ActiveAccount from '@app/pages/public/ActivateAccount';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import withApplicationTheme from '@app/theme/withApplicationTheme';
import ForgetPassword from './application/pages/public/ForgetPassword';
import SetNewPassword from './application/pages/public/SetNewPassword';
import ActiveAccountRequest from './application/pages/public/ActiveAccountRequest';
import PasswordResetInstructions from '@app/pages/public/PasswordResetInstructions';
import ActivateAccountSuccessInstructions from '@app/pages/public/ActivateAccountSuccessInstructions';
import RemoveGoogleChromeAutoFillBackground from '@app/components/RemoveGoogleChromeAutoFillBackground';

// if (process.env.NODE_ENV === 'development') initDevSession();

const root = ReactDOM.createRoot(document.getElementById('root'));

const RouterElementContainer = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  background: theme.palette.background.paper,
}));

const ThemeWrapper = withApplicationTheme(({ theme }) => {
  return (
    <ThemeProvider theme={theme}>
      <ToastWithoutMargin />
      <CssBaseline />
      <GlobalEventListener />
      <RemoveGoogleChromeAutoFillBackground>
        <HelmetProvider context={{}}>
          <I18nextProvider i18n={i18n}>
            <Translator>
              {translator => (
                <Routes>
                  <Route path="*" element={<RouterElementContainer children={<Application translator={translator} />} />} />

                  {/* Login */}
                  <Route path="/login" element={<RouterElementContainer children={<LoginPage translator={translator} />} />} />

                  {/* Impersonate: Path used to login an operator from hub system. This /impersonate?token=<TOKEN_HERE> */}
                  <Route path="/impersonate" element={<RouterElementContainer children={<Impersonate translator={translator} />} />} />

                  {/* Reset Password */}
                  <Route path="/forgot-password" element={<RouterElementContainer children={<ForgetPassword translator={translator} />} />} />
                  <Route path="/password-reset-instructions" element={<RouterElementContainer children={<PasswordResetInstructions translator={translator} />} />} />
                  <Route path="/set-new-password" element={<RouterElementContainer children={<SetNewPassword translator={translator} />} />} />

                  {/* Activate account pages */}
                  <Route path="/active-account-request" element={<RouterElementContainer children={<ActiveAccountRequest translator={translator} />} />} />
                  <Route path="/active-account-instructions" element={<RouterElementContainer children={<ActivateAccountSuccessInstructions translator={translator} />} />} />
                  <Route path="/active-account" element={<RouterElementContainer children={<ActiveAccount translator={translator} />} />} />
                </Routes>
              )}
            </Translator>
          </I18nextProvider>
        </HelmetProvider>
      </RemoveGoogleChromeAutoFillBackground>
    </ThemeProvider>
  );
});

root.render(
  <BrowserRouter>
    <ThemeWrapper />
  </BrowserRouter>,
);

const ToastWithoutMargin = () => <Box sx={{ '& div[role="status"]': { margin: 0 } }} children={<Toaster />} />;

reportWebVitals();
